import { useAsyncData, useRequestURL, useRoute, useRouteParams } from '#imports'

import { buildPropsWithCorrectLinks } from '@backmarket/nuxt-layer-cms/utils/buildPropsWithCorrectLinks'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { dewebviewifyRouteName } from '~/scopes/webviews/utils'

import { CMS } from '../../../cms/routes-names'

export async function useFetchContentHub() {
  const $httpFetch = useHttpFetch()
  const routeParams = useRouteParams()
  const route = useRoute()
  const routeName = String(route.name)
  const currentUrl = useRequestURL()

  const pageCategory =
    dewebviewifyRouteName(routeName) === CMS.ARTICLE_ROOT_HUB
      ? 'content'
      : routeParams.pageCategory

  const { data, error } = await useAsyncData(
    getAsyncDataKey('cms-article-hub', { pageCategory }),
    () => {
      return $httpFetch('/content/page/article-category/:pageCategory', {
        pathParams: { pageCategory },
      })
    },
    {
      transform: (contentHubResponse) => {
        const categories = contentHubResponse.categories.map((category) => {
          return {
            ...category,
            props: buildPropsWithCorrectLinks({
              props: category.props,
              currentUrl,
            }),
          }
        })

        const featured = contentHubResponse.featured
          ? {
              ...contentHubResponse.featured,
              props: buildPropsWithCorrectLinks({
                props: contentHubResponse.featured.props,
                currentUrl,
              }),
            }
          : null

        const articles = contentHubResponse.articles.map((article) => {
          return buildPropsWithCorrectLinks({ props: article, currentUrl })
        })

        const categoryTree = {
          ...contentHubResponse.categoryTree,
          props: buildPropsWithCorrectLinks({
            props: contentHubResponse.categoryTree.props,
            currentUrl,
          }),
        }

        return {
          ...contentHubResponse,
          displayBreadcrumb:
            typeof contentHubResponse.displayBreadcrumb !== 'boolean'
              ? true
              : contentHubResponse.displayBreadcrumb,
          articles,
          categories,
          featured,
          categoryTree,
        }
      },
    },
  )

  return { data, error }
}
